import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: 18
  }
}));
